import { configureStore } from "@reduxjs/toolkit";
import { webinarReducer } from "./reducers/webinar";

const initialState = {
    webinar: {
        signature: null,
        webinarId: null,
        name: null,
        email: null,
    },
};

const store = configureStore({
    reducer: {
        webinar: webinarReducer,
    },
    preloadedState: initialState,
});

export default store;
